import * as React from 'react';
import { isWelcomeStep } from '../../utils/uiOverrides';
import WelcomeHeader from './WelcomeHeader';
import WelcomeHeaderAppily from './WelcomeHeaderAppily';
import StepHeader from './StepHeader';

interface Props {
  currentStep?: number;
  currentStepId?: number;
  fieldIDs: string[];
  classes?: any;
  formTitle?: string;
  formSubTitle?: string;
  logo?: string;
  appilyAuth?: boolean;
}

const Header: React.FC<Props> = props => {
  if (isWelcomeStep(props.currentStepId) && !props.appilyAuth) {
    return <WelcomeHeader {...props} />;
  } else if (isWelcomeStep(props.currentStepId) && props.appilyAuth) {
    return <WelcomeHeaderAppily {...props} />;
  } else if (props.appilyAuth) {
    return <WelcomeHeaderAppily {...props} />;
  }

  return <StepHeader {...props} />;
};

export default Header;
try {
    // @ts-ignore
    header.displayName = "header";
    // @ts-ignore
    header.__docgenInfo = { "description": "", "displayName": "header", "props": { "currentStep": { "defaultValue": null, "description": "", "name": "currentStep", "required": false, "type": { "name": "number" } }, "currentStepId": { "defaultValue": null, "description": "", "name": "currentStepId", "required": false, "type": { "name": "number" } }, "fieldIDs": { "defaultValue": null, "description": "", "name": "fieldIDs", "required": true, "type": { "name": "string[]" } }, "classes": { "defaultValue": null, "description": "", "name": "classes", "required": false, "type": { "name": "any" } }, "formTitle": { "defaultValue": null, "description": "", "name": "formTitle", "required": false, "type": { "name": "string" } }, "formSubTitle": { "defaultValue": null, "description": "", "name": "formSubTitle", "required": false, "type": { "name": "string" } }, "logo": { "defaultValue": null, "description": "", "name": "logo", "required": false, "type": { "name": "string" } }, "appilyAuth": { "defaultValue": null, "description": "", "name": "appilyAuth", "required": false, "type": { "name": "boolean" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/header/header.tsx#header"] = { docgenInfo: header.__docgenInfo, name: "header", path: "src/components/header/header.tsx#header" };
}
catch (__react_docgen_typescript_loader_error) { }